import { render, staticRenderFns } from "./about.vue?vue&type=template&id=45531cd4&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"
import style0 from "../assets/css/about.css?vue&type=style&index=0&id=45531cd4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45531cd4",
  null
  
)

export default component.exports